// extracted by mini-css-extract-plugin
export var rule = "judge-module--rule--RfzVV";
export var awardImgs = "judge-module--awardImgs--2IhkU";